import React from 'react';
import { Button } from '@material-ui/core';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
function SortButton(_a) {
    var sortDesc = _a.sortDesc, onClick = _a.onClick;
    var icon = sortDesc ? React.createElement(ArrowDownwardIcon, null) : React.createElement(ArrowUpwardIcon, null);
    return (React.createElement(Button, { endIcon: icon, onClick: onClick, color: "secondary", "data-testid": "lcui-sortbyname-button" }, "Sort by name"));
}
export default SortButton;
//# sourceMappingURL=SortButton.js.map